/**
 * The footer strip at the bottom of every workspace page. Mirrors the
 * original `lorenza.html` footer — small Lopettia logomark on the left,
 * "BRIEFER · INTAKE INSTRUMENT V2.1 · BUILT FOR EXECUTIVE INTENT
 * CAPTURE" in JetBrains Mono, date stamp on the right.
 */
export function PageFooter() {
  const today = new Date()
    .toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    .toUpperCase()
  return (
    <footer className="page-footer">
      <a href="/" className="lop-logo lop-logo--xs" aria-label="Lopettia home">
        <img src="/brand/lopettia-logomark.svg" alt="Lopettia" />
      </a>
      <span className="page-footer__line">
        BRIEFER · INTAKE INSTRUMENT V2.1 · BUILT FOR EXECUTIVE INTENT CAPTURE
      </span>
      <span className="page-footer__date">{today}</span>
    </footer>
  )
}
